import { createSlice } from '@reduxjs/toolkit';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/es/storage';
import { RootState } from './store';

export interface KlineDataPoint {
  timestamp: number
  price: number
}

export interface CoinMeta {
  symbol: string
  icon: string
  kline_24h?: KlineDataPoint[]
}

interface CoinIconsState {
  icons: Record<string, string>
  klineData: Record<string, KlineDataPoint[]>
  lastFetched: number | null
  isLoading: boolean
}

const coinIconInitState: CoinIconsState = {
  icons: {},
  klineData: {},
  lastFetched: null,
  isLoading: false,
};

const coinIconsSlice = createSlice({
  name: 'coinIcons',
  initialState: coinIconInitState,
  reducers: {
    setCoinIcons: (
      state,
      action: { payload: CoinIconsState },
    ) => {
      state.icons = action.payload.icons || {};
      state.klineData = action.payload.klineData || {};
      state.lastFetched = action.payload.lastFetched || null;
      state.isLoading = action.payload.isLoading || false;
    },

    setIsLoading: (state, action: { payload: boolean }) => {
      state.isLoading = action.payload;
    }
  }
})

export const { setCoinIcons, setIsLoading } =
  coinIconsSlice.actions;

export const reduxIcons = (state: RootState) => state.coinIcons.icons;
export const reduxKlineData = (state: RootState) => state.coinIcons.klineData;
export const reduxLastFetch = (state: RootState) => state.coinIcons.lastFetched;
export const reduxIsLoading = (state: RootState) => state.coinIcons.isLoading;

export default persistReducer({
  key: 'coinIcons',
  storage,
  blacklist: ['isLoading']
}, coinIconsSlice.reducer)